"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _button = require("@jsluna/button");

var _typography = require("@jsluna/typography");

var _modal = require("@jsluna/modal");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InfoModal = function InfoModal(props) {
  var isOpen = props.isOpen,
      headerText = props.headerText,
      bodyText = props.bodyText,
      buttonText = props.buttonText,
      handleClose = props.handleClose;
  return /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    className: "ln-u-hard",
    open: isOpen,
    handleClose: handleClose,
    headingId: "info-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-top*4"
  }, /*#__PURE__*/_react.default.createElement(_typography.Display2, null, headerText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-top*2 ln-u-margin-bottom*3"
  }, bodyText), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    className: "ln-u-padding-sides*4",
    onClick: handleClose
  }, buttonText)));
};

InfoModal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  headerText: _propTypes.PropTypes.string.isRequired,
  bodyText: _propTypes.PropTypes.string.isRequired,
  buttonText: _propTypes.PropTypes.bool.isRequired,
  handleClose: _propTypes.PropTypes.func.isRequired
};
var _default = InfoModal;
exports.default = _default;